import moment from 'moment'
import React, {useEffect, useMemo, useState} from 'react'
import {Dropdown} from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import {useDispatch, useSelector} from 'react-redux'
import {regions, useDebounce} from '../../../../../_metronic/helpers'
import {GetPurchaseHistory} from '../../GatewayManagement/GatewayManagementSlice/GatewayManagementSlice'
import GlobalRateCardList from '../../Setup/GlobalRateCard/GlobalRateCardList'
import AddCreditPopup from './modal/AddCreditPopup'
import RemoveCreditPopup from './modal/RemoveCreditPopup'
import CreateInvoice from './modal/CreateInvoice'
import {GetPriceRuleList} from '../../Setup/GlobalRateCard/GlobalRateCardSlice/GlobalRateCardSlice'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import DedicatedNumberListModel from '../../DedicatedNumber/modal/DedicatedNumberListModel'
import {ProfileDetailData} from '../../../../Redux/AdminPanel/ProfileDetailsSlice'
import {fetchAsyncUserDetails} from '../../../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import LimitCreditModal from './modal/LimitCreditPopup'
import {
  ACCOUNT_TYPE,
  REGION_ARRAYS,
  STRIPE_PAYMENT_STATUS,
} from '../../../../Utils/Constant/ConstantForWebsite'
import FlatRatePriceModal from './modal/FlatRateCreditPopup'
import {toUpper} from 'lodash'
import {useSendDraftInvoiceToCustomerMutation} from '../../../../../services/cellcast'
import {toast} from 'react-toastify'
import clsx from 'clsx'
import {useChangeCreditStatusMutation} from '../../../../../services/cellcast.v2'
import Select from 'react-select'
import {useRemainingBalanceRegionMutation} from '../../../../../services/cellcast.v3'
import {useLocation} from 'react-router-dom'
import UserCoupon from './UserCoupon'

const Billing = () => {
  const [addCredit, setAddCredit] = useState(false)

  const location = useLocation()
  const {userProp} = location.state || ({} as any)

  const purchase_history = useSelector((state: any) => state?.paymentGateway?.userPurchase)

  const userDataState = useSelector((state: any) => state?.ProfileData?.ProfileData?.user)
  const ProfileDetatileState = userProp?.user ? userProp.user : userDataState

  const userCreditState = useSelector((state: any) => state?.ProfileData?.ProfileData?.credits)
  const ProfileDetailCredit = userProp?.user ? userProp.credits : userCreditState

  const credit = useSelector((state: any) => state?.ProfileData?.ProfileData)
  const dispatch = useDispatch()
  const [addCreditPopup, setAddCreditPopup] = useState(false)
  const [removeCreditPopup, setRemoveCreditPopup] = useState(false)
  const [limitCreditPopup, setLimitCreditPopup] = useState(false)
  const [flatRatePricePopup, setFlatRatePricePopup] = useState(false)
  const [invoicePopup, setInvoicePopup] = useState(false)
  const [DNPopup, setDNPopup] = useState(false)
  const [page, setPage] = useState({
    page: 1,
    size: 10,
    search: '',
    duration: 'month',
  })

  const fetchPurchaseHistory = ({page, id}: any) => {
    dispatch(GetPurchaseHistory({page, id}))
  }

  const [region, setRegion] = useState<any>(REGION_ARRAYS[0].value)
  const [fetchBalanceRegion, {data: balanceRegionData}] = useRemainingBalanceRegionMutation()

  const [sendInvoice] = useSendDraftInvoiceToCustomerMutation()
  const [updateInvoiceStatus] = useChangeCreditStatusMutation()
  const AddCreditpopup = useMemo(
    () => (
      <AddCreditPopup
        show={addCreditPopup}
        handleClose={() => {
          setAddCreditPopup(false)
        }}
      />
    ),
    [addCreditPopup]
  )

  const RemoveCredit = useMemo(
    () => (
      <RemoveCreditPopup
        smsCredit={ProfileDetailCredit?.sms || 0}
        mmsCredit={ProfileDetailCredit?.mms || 0}
        userId={ProfileDetatileState?._id || '-'}
        callbackFn={() => {
          setRemoveCreditPopup(false)
          dispatch(ProfileDetailData(ProfileDetatileState?._id || '-'))
          dispatch(fetchAsyncUserDetails())
        }}
        userName={ProfileDetatileState?.name || '-'}
        show={removeCreditPopup}
        handleClose={() => setRemoveCreditPopup(false)}
      />
    ),
    [
      ProfileDetailCredit?.mms,
      ProfileDetailCredit?.sms,
      ProfileDetatileState?._id,
      ProfileDetatileState?.name,
      dispatch,
      removeCreditPopup,
    ]
  )
  const CreateinvoicePopup = useMemo(
    () => (
      <CreateInvoice
        show={invoicePopup}
        handleClose={() => {
          setInvoicePopup(false)
          fetchPurchaseHistory({page, id: ProfileDetatileState?._id})
        }}
      />
    ),
    [invoicePopup]
  )
  const DedicatedNumberListPopup = useMemo(
    () => <DedicatedNumberListModel show={DNPopup} handleClose={() => setDNPopup(false)} />,
    [DNPopup]
  )

  const LimitCreditPopup = useMemo(
    () => (
      <LimitCreditModal
        show={limitCreditPopup}
        handleClose={() => {
          setLimitCreditPopup(false)
          dispatch(ProfileDetailData(ProfileDetatileState?._id || '-'))
          dispatch(fetchAsyncUserDetails())
        }}
      />
    ),
    [limitCreditPopup]
  )

  const FlatRatePricePopup = useMemo(
    () => (
      <FlatRatePriceModal
        show={flatRatePricePopup}
        handleClose={() => {
          setFlatRatePricePopup(false)
          dispatch(ProfileDetailData(ProfileDetatileState?._id || '-'))
          dispatch(fetchAsyncUserDetails())
        }}
      />
    ),
    [flatRatePricePopup]
  )

  const debouncedSearchTerm = useDebounce(page?.search, 3000)
  useEffect(() => {
    fetchPurchaseHistory({page, id: ProfileDetatileState?._id})
  }, [debouncedSearchTerm, page.page, page.size, page.duration])

  useEffect(() => {
    dispatch(GetPriceRuleList({accountId: ProfileDetatileState?.accountId}))
    dispatch(ProfileDetailData(ProfileDetatileState?._id || '-'))
    dispatch(fetchAsyncUserDetails())
  }, [])

  useEffect(() => {
    if (region !== REGION_ARRAYS[0].value) {
      fetchBalanceRegion({userId: ProfileDetatileState?._id, region: region})
    }
  }, [region])

  const isPostPaid = ProfileDetatileState?.accountType === ACCOUNT_TYPE.POSTPAID
  const isFlatRateEnabled =
    ProfileDetatileState?.postPaidLimitConfig?.smsFlatRate ||
    ProfileDetatileState?.postPaidLimitConfig?.mmsFlatRate

  return (
    <>
      {AddCreditpopup}
      {RemoveCredit}
      {CreateinvoicePopup}
      {DedicatedNumberListPopup}
      {LimitCreditPopup}
      {FlatRatePricePopup}
      <div className='col-md-12'>
        <div className='card mb-6'>
          <div className='card-body'>
            <div className='d-flex flex-wrap flex-sm-nowrap'>
              <div className='flex-grow-1'>
                <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                  <div className='d-flex flex-column'>
                    <div className='d-flex align-items-center mb-2'>
                      <a href='#' className='text-gray-900 text-hover-primary fs-2 fw-bolder me-1'>
                        Credit Balance
                      </a>
                    </div>
                  </div>

                  <div className='d-flex mb-3'>
                    <Dropdown>
                      <Dropdown.Toggle
                        className='btn btn-light-primary btn-sm me-2'
                        id='dropdown-basic'
                      >
                        Manage credits
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item
                          className='menu-content  p-3 fs-8 text-uppercase'
                          onClick={() => {
                            setInvoicePopup(true)
                          }}
                        >
                          Create invoice
                        </Dropdown.Item>
                        <Dropdown.Item
                          className='menu-content  p-3 fs-8 text-uppercase'
                          onClick={() => {
                            setAddCreditPopup(true)
                          }}
                        >
                          Add credit
                        </Dropdown.Item>
                        <Dropdown.Item
                          className='menu-content  p-3 fs-8 text-uppercase'
                          onClick={() => {
                            setRemoveCreditPopup(true)
                          }}
                        >
                          Remove credit
                        </Dropdown.Item>
                        {isPostPaid && (
                          <>
                            <Dropdown.Item
                              className='menu-content  p-3 fs-8 text-uppercase'
                              onClick={() => {
                                setFlatRatePricePopup(true)
                              }}
                            >
                              Set Flat Rate
                            </Dropdown.Item>

                            <Dropdown.Item
                              className='menu-content  p-3 fs-8 text-uppercase'
                              onClick={() => {
                                setLimitCreditPopup(true)
                              }}
                            >
                              Limit credit
                            </Dropdown.Item>
                          </>
                        )}
                        <Dropdown.Item
                          className='menu-content  p-3 fs-8 text-uppercase'
                          onClick={() => {
                            setDNPopup(true)
                          }}
                        >
                          Add Dedicated Numbers
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>

                <div className='d-flex align-items-center mb-2'>
                  <h5>Choose region</h5>
                </div>
                <div className='mt-5 mb-5'>
                  <Select
                    options={REGION_ARRAYS}
                    value={regions?.find((key: any) => key?.value === region)}
                    onChange={(e: any) => setRegion(e?.value)}
                    className='form-select form-select-solid form-select-lg'
                  />
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block text-danger'></div>
                  </div>
                </div>
                <div className='d-flex align-items-center mb-2'>
                  <h5>Current Credit Balance</h5>
                </div>
                <div className='d-flex flex-wrap flex-stack'>
                  <div className='d-flex flex-column flex-grow-1'>
                    <div className='d-flex flex-wrap justify-content-between gap-3'>
                      <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 flex-grow-1'>
                        <div className='d-flex align-items-center'>
                          <div className='fs-2 fw-bolder text-success'>
                            {region !== REGION_ARRAYS[0].value
                              ? balanceRegionData?.data?.sms || 0
                              : credit?.credits?.sms}{' '}
                            SMS
                          </div>
                        </div>
                        <div className='fw-light text-gray-400'>Last purchased on 12/07/2022</div>
                      </div>
                      <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 flex-grow-1'>
                        <div className='d-flex align-items-center'>
                          <div className='fs-2 fw-bolder text-info'>
                            {region !== REGION_ARRAYS[0].value
                              ? balanceRegionData?.data?.mms || 0
                              : credit?.credits?.mms}{' '}
                            MMS
                          </div>
                        </div>
                        <div className='fw-light text-gray-400'>Last purchased on 12/07/2022</div>
                      </div>
                    </div>
                  </div>
                </div>

                {isPostPaid && (
                  <>
                    {isFlatRateEnabled && (
                      <>
                        <div className='d-flex align-items-center mb-2'>
                          <h5>Flat Rate Pricing Mechanism</h5>
                        </div>
                        <div className='d-flex flex-wrap flex-stack'>
                          <div className='d-flex flex-column flex-grow-1'>
                            <div className='d-flex flex-wrap justify-content-between gap-3'>
                              <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 flex-grow-1'>
                                <div className='d-flex align-items-center'>
                                  <div className='fs-2 fw-bolder text-success'>
                                    {ProfileDetatileState?.postPaidLimitConfig?.smsFlatRatePrice} /
                                    SMS
                                  </div>
                                </div>
                                <div className='fw-light text-gray-400'>Flat Rate</div>
                              </div>
                              <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 flex-grow-1'>
                                <div className='d-flex align-items-center'>
                                  <div className='fs-2 fw-bolder text-info'>
                                    {ProfileDetatileState?.postPaidLimitConfig?.mmsFlatRatePrice} /
                                    MMS
                                  </div>
                                </div>
                                <div className='fw-light text-gray-400'>Flat Rate</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    <div className='d-flex align-items-center mb-2'>
                      <h5>Credit Limit</h5>
                    </div>

                    <div className='d-flex flex-wrap flex-stack'>
                      <div className='d-flex flex-column flex-grow-1'>
                        <div className='d-flex flex-wrap justify-content-between gap-3'>
                          <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 flex-grow-1'>
                            <div className='d-flex align-items-center'>
                              <div className='fs-2 fw-bolder text-success'>
                                {ProfileDetatileState?.postPaidLimitConfig?.smsLimitPerMonth} SMS
                                LIMIT
                              </div>
                            </div>
                            <div className='fw-light text-gray-400'>
                              Created at{' '}
                              {moment(ProfileDetatileState?.postPaidLimitConfig?.updatedAt).format(
                                'l'
                              )}
                            </div>
                          </div>
                          <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 flex-grow-1'>
                            <div className='d-flex align-items-center'>
                              <div className='fs-2 fw-bolder text-info'>
                                {ProfileDetatileState?.postPaidLimitConfig?.mmsLimitPerMonth} MMS
                                LIMIT
                              </div>
                            </div>
                            <div className='fw-light text-gray-400'>
                              Created at{' '}
                              {moment(ProfileDetatileState?.postPaidLimitConfig?.updatedAt).format(
                                'l'
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        
        <UserCoupon />

        <div className='card mb-6'>
          <div className='card-header card-header-stretch border-bottom-0'>
            <div className='card-title d-flex align-items-center'>
              <h3 className='fw-bolder m-0 text-gray-800'>Invoices</h3>
            </div>
            <div className='card-toolbar m-0'>
              <ul className='nav nav-stretch  nav-line-tabs border-transparent'>
                <li className='nav-item'>
                  <a
                    className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1 ${
                      page.duration == 'month' && 'active'
                    }`}
                    data-bs-toggle='tab'
                    onClick={() => setPage({...page, duration: 'month'})}
                  >
                    Months
                  </a>
                </li>
                <li className='nav-item'>
                  <a
                    className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1 ${
                      page.duration == 'week' && 'active'
                    }`}
                    data-bs-toggle='tab'
                    onClick={() => setPage({...page, duration: 'week'})}
                  >
                    Week
                  </a>
                </li>
                <li className='nav-item'>
                  <a
                    className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1 ${
                      page.duration == 'day' && 'active'
                    }`}
                    data-bs-toggle='tab'
                    onClick={() => setPage({...page, duration: 'day'})}
                  >
                    Day
                  </a>
                </li>
                <li className='nav-item'>
                  <a
                    className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1 ${
                      page.duration == 'all' && 'active'
                    }`}
                    data-bs-toggle='tab'
                    onClick={() => setPage({...page, duration: 'all'})}
                  >
                    ALL
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className='card-body pt-2'>
            <div className='tab-content'>
              <div className='table-responsive'>
                <table className='table align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bolder text-muted bg-light text-bolder table-row-gray-200 border-bottom border-top'>
                      <th className='ps-4 min-w-125px rounded-start fw-bolder'>Created</th>
                      <th className='min-w-125px fw-bolder'>Paid On</th>
                      <th className='min-w-100px fw-bolder'>Invoice Id</th>
                      <th className='min-w-100px fw-bolder'>Type</th>
                      <th className='min-w-100px fw-bolder'>Total MMS</th>
                      <th className='min-w-100px fw-bolder'>Total SMS</th>
                      <th className='min-w-100px fw-bolder'>Total + GST</th>
                      <th className='min-w-100px fw-bolder'>Status</th>
                      {/* <th className='min-w-70px fw-bolder'>Status</th> */}
                      <th className='min-w-150px  rounded-end fw-bolder text-end pe-10'>Actions</th>
                    </tr>
                  </thead>
                  <tbody className='p-5'>
                    {purchase_history?.items?.map((data: any, idx: number) => {
                      const badgeClass = clsx('badge', {
                        'badge-light-success': data?.status === 'paid',
                        'badge-light-info': data?.status === 'open',
                        'badge-light-danger': data?.status === 'draft',
                      })

                      return (
                        <tr key={idx}>
                          <td className='ps-3 table-row-gray-200 border-bottom border-top ps-5'>
                            <a
                              //   href='#'
                              className='text-gray-400 d-block mb-1 fs-6'
                            >
                              {data?.createdAt
                                ? moment(data?.createdAt).format('MMM DD YYYY')
                                : ''}
                            </a>
                          </td>
                          <td className='table-row-gray-200 border-bottom border-top'>
                            <a
                              //   href='#'
                              className='text-gray-400 d-block mb-1 fs-6'
                            >
                              {data?.status === 'paid' && data?.purchasedDate
                                ? moment(data?.purchasedDate).format('MMM DD YYYY')
                                : ''}
                            </a>
                          </td>
                          <td className='table-row-gray-200 border-bottom border-top'>
                            <a
                              //   href='#'
                              className='text-gray-400 d-block mb-1 fs-6'
                            >
                              {data?.invoice}
                            </a>
                          </td>
                          <td className='table-row-gray-200 border-bottom border-top'>
                            <a
                              //   href='#'
                              className={
                                data?.type === 'SMS'
                                  ? 'badge badge-light-info'
                                  : 'badge badge-light-success'
                              }
                            >
                              {data?.type?.toUpperCase()}
                            </a>
                          </td>
                          <td className='table-row-gray-200 border-bottom border-top'>
                            <a
                              //   href='#'
                              className='text-gray-400 d-block mb-1 fs-6'
                            >
                              {data?.type == 'mms' && data?.allowedMessages}
                            </a>
                          </td>
                          <td className='table-row-gray-200 border-bottom border-top'>
                            <a
                              //   href='#'
                              className='text-gray-400 d-block mb-1 fs-6'
                            >
                              {data?.type == 'sms' && data?.allowedMessages}
                            </a>
                          </td>
                          <td className='table-row-gray-200 border-bottom border-top'>
                            <a
                              //   href='#'
                              className='text-gray-400 d-block mb-1 fs-6'
                            >
                              ${data?.amount}
                            </a>
                          </td>
                          <td className='table-row-gray-200 border-bottom border-top'>
                            <a className={badgeClass}>
                              {toUpper(data?.status === 'open' ? 'unpaid' : data?.status)}
                            </a>
                          </td>
                          <td className='table-row-gray-200 border-top text-end pe-5'>
                            {[STRIPE_PAYMENT_STATUS.PAID].includes(data?.status) && (
                              <button
                                onClick={() => window.open(`${data.invoicePdf}`, '_self')}
                                className='btn btn-sm btn-light btn-active-light-primary me-3 fw-500'
                              >
                                Download
                              </button>
                            )}

                            {[STRIPE_PAYMENT_STATUS.OPEN].includes(data?.status) && (
                              <button
                                onClick={() => {
                                  updateInvoiceStatus({invoiceIds: [data?.invoice]})
                                    .unwrap()
                                    .then((res) => {
                                      toast.success(res.message)
                                      fetchPurchaseHistory({page, id: ProfileDetatileState?._id})
                                    })
                                    .catch((err) => {
                                      toast.error(err.message)
                                    })
                                }}
                                className='btn btn-sm btn-success btn-active-light-primary me-3 fw-500'
                              >
                                Paid
                              </button>
                            )}

                            {data?.status === STRIPE_PAYMENT_STATUS.DRAFT && data?.invoice && (
                              <button
                                onClick={() => {
                                  sendInvoice({invoiceIds: [data?.invoice]})
                                    .unwrap()
                                    .then((res) => {
                                      toast.success(res.message)
                                      fetchPurchaseHistory({page, id: ProfileDetatileState?._id})
                                    })
                                    .catch((err) => {
                                      toast.error(err.message)
                                    })
                                }}
                                className='btn btn-sm btn-success btn-active-light-primary me-3 fw-500'
                              >
                                Approve
                              </button>
                            )}
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>

                <div className='abcd '>
                  {/* <select onChange={(e: any) => setPage({...page, size: e.target.value,page:1})}>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={purchase_history?.total}>ALL</option>
                </select> */}
                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={purchase_history?.totalPages}
                    onPageChange={(e) => setPage({...page, page: e.selected + 1})}
                    containerClassName={'pagiantion'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Billing
